import { Box, Paper, Typography, useTheme } from '@mui/material'
import { formatNumberAsPrice } from 'components-ui/src/shared/common'
import { Spacer } from 'components-ui/src/spacer/spacer'
import useMediaQuery from '@mui/material/useMediaQuery'
import { i18WithParams as t } from '@shared/locale'

export const WalletBalance = ({ walletBalanceTotal }: { walletBalanceTotal: number }) => {
  const theme = useTheme()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Paper elevation={1} sx={{ p: 2, marginBottom: 2, marginTop: 2 }}>
      <Box>
        <Typography variant="h5" pl={isBelowMD ? 2 : 0}>
          {t('profile.paymentMethod.wallet')}
        </Typography>
        <Spacer height={1} />
        <Typography variant="body1bold" mb={1}>
          {formatNumberAsPrice(walletBalanceTotal)}
        </Typography>
        <Spacer height={1} />
        <Typography variant="body2" color="textSecondary">
          {t('profile.paymentMethod.wallet.note')}
        </Typography>
      </Box>
    </Paper>
  )
}
